
























import {Component, Vue} from "vue-property-decorator";
import FilmList from "@/modules/Rhizome/components/FilmList.vue";
import {RhizomeViewType} from "@/modules/Rhizome/interfaces/state.interface";
import RhizomeCloud from "@/modules/Rhizome/components/RhizomeCloud.vue";
import Header from "@/components/Header.vue";
import FilmModal from '@/components/FilmModal.vue';
import ThemesModal from '@/components/ThemesModal.vue';
import TimeoutModal from '@/components/TimeoutModal.vue';
import AboutModal from '@/components/AboutModal.vue';
import HelpModal from '@/components/HelpModal.vue';

@Component({
  components: {
    Header,
    FilmList,
    FilmModal,
    RhizomeCloud,
    ThemesModal,
    TimeoutModal,
    AboutModal,
    HelpModal,
  }
})

export default class RhizomePage extends Vue {
  isLoading = true;
  mediaQuery: any = null;
  viewTypes = RhizomeViewType;

  get isKiosk() {
    return this.$store.state.rhizome.kioskMode;
  }

  get isMenuOpen() {
    return this.$store.state.dialog.menu;
  }
  get activeView(): RhizomeViewType {
    return this.$store.state.rhizome.viewType;
  }

  get showThemesModal(): boolean {
    return this.$store.state.rhizome.showThemesModal;
  }

  get showTimeoutModal(): boolean {
    return this.$store.state.rhizome.showTimeoutModal;
  }

  get showAboutModal(): boolean {
    return this.$store.state.rhizome.showAboutModal;
  }

  get showHelpModal(): boolean {
    return this.$store.state.rhizome.showHelpModal;
  }

  get kioskCurrentFilmId(): string {
    return this.$store.state.rhizome.kioskCurrentFilmId;
  }

  get isError(): boolean {
    return this.$store.state.rhizome.errorOnRequest;
  }
  set activeView(value: RhizomeViewType) {
    this.$store.commit('rhizome/setPropertyInState', { name: 'viewType', value })
  }
  async created() {
    this.$store.commit('rhizome/setPropertyInState', { name: 'errorOnRequest', value: false });
    if (!this.$store.state.rhizome.filmsList.length) {
      try {
        await this.$store.dispatch('rhizome/initRhizome');
        this.$store.commit('rhizome/setPropertyInState', { name: 'errorOnRequest', value: false });
      }
      catch (e) {
        console.log(e);
        this.$store.commit('rhizome/setPropertyInState', { name: 'errorOnRequest', value: true });
      }
    }
      this.isLoading = false;
  }
  mounted() {
    this.activeView = RhizomeViewType.CLOUD;
    this.mediaQuery = window.matchMedia("(max-width: 500px)");
    this.checkMedia(this.mediaQuery);
    this.mediaQuery.addListener(this.checkMedia);
  }
  checkMedia(e) {
    if (e.matches) {
      this.activeView = this.viewTypes.LIST;
    }
  }
  destroyed() {
    this.mediaQuery.removeListener(this.checkMedia);
  }
}
